import type { ReactNode } from "react"

import { withPalette, type Palette } from "@/components/marketplace/palette"

// Re-themes its subtree by setting a .palette-* class; descendants inherit the
// palette vars via the CSS cascade (nearest-wins over the page root).
export const PaletteScope = ({ palette, className, children }: { palette?: Palette; className?: string; children: ReactNode }) => (
  <div className={withPalette(palette, className)}>{children}</div>
)
